import { useEffect, useState } from "react";
import { navigate } from "gatsby";
import { ERRORS } from "../helpers/errors";
import { log } from "../helpers";

const useHash = (hash) => {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleHashChange = () => {
      try {
        if (typeof window !== `undefined`) {
          if (window.location.hash === hash) {
            if (document.readyState === "complete") {
              navigate(hash);
              setIsScrolled(true);
            }
          }
        }
      } catch (error) {
        log(error, ERRORS.URL_ERRORS.ERROR_PARSING_URL_PARAMETERS, true);
      }
    };
    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  useEffect(() => {
    if (isScrolled) {
      setTimeout(() => {
        const partners = document.querySelector(hash);
        partners?.getBoundingClientRect().top !== 0 &&
          partners?.scrollIntoView({
            block: "start",
            behavior: "smooth",
          });
      }, 1000);
    }
  }, [isScrolled]);
};

export default useHash;
